<template>
  <div class="page-box">
    <!-- 头部 -->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />

    <!-- 内容区域 -->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 质控中心哨点医院招募计划</div>
        <div class="recruitment-box">
          <div class="recruitment-title">质控中心哨点医院招募计划</div>
          <el-form v-if="!formSubmitted" :model="form" ref="formRef" :rules="rules" label-position="top">
            <div v-for="(item, index) in sentinelHospital" :key="index">
              <el-form-item v-if="item.type == 'ssqselect'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-cascader v-model="form[item.field]" :options="cityList" :props="{value: 'label'}"></el-cascader>
              </el-form-item>

              <el-form-item v-if="item.type == 'text'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-input v-model="form[item.field]" placeholder="请输入" :maxlength="item.maxLength" />
              </el-form-item>

              <el-form-item v-if="item.type == 'radio'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-select v-model="form[item.field]" placeholder="请选择">
                  <el-option v-for="(itemTwo, indexTwo) in item.options" :key="indexTwo" :label="itemTwo" :value="itemTwo" />
                </el-select>
              </el-form-item>
            </div>
            <el-form-item style="text-align: center;">
              <el-button class="bt" type="primary" @click="submitForm">提交</el-button>
            </el-form-item>
          </el-form>
          <img v-else src="@/assets/images/ok.png" style="margin: 50px auto;display: block;" />
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer-bar />
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import { getLiaisonRecruitment, addSentinelHospital } from '@/api/home'
const provinces = require('@/assets/address.json');
export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav },
  data() {
    return {
      formSubmitted: false,
      selectedIndex: null,
      form: {},
      rules: {},
      sentinelHospital: [], // 题目列表
      cityList: [],
    };
  },
  methods: {
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.addSentinelHospital()
        } else {
          this.$message.error("请完善表单内容！");
          return false;
        }
      });
    },
    // 哨点医院问题列表
    getLiaisonRecruitment() {
      getLiaisonRecruitment().then(res => {
        for (let i = 0; i < res.data.length; i++) {
          this.$set(this.form, res.data[i].field, '')
          this.$set(this.rules, res.data[i].field, [{
            required: true,
            message: res.data[i].type == 'text' ? `请输入${res.data[i].title}` : `请选择${res.data[i].title}`,
            trigger: res.data[i].type == 'text' ? 'blur' : 'change'
          }])
        }
        this.$nextTick(() => {
          this.sentinelHospital = res.data
        })
      })
    },
    // 新增哨点医院招募信息
    addSentinelHospital() {
      let data = JSON.parse(JSON.stringify(this.form))
      if(data.district) {
        data.district = data.district.join(' ')
      }
      addSentinelHospital(data).then(res => {
        this.$message.success("提交成功！");
        this.formSubmitted = true;
      })
    },
    getCityListTree() {
      this.cityList = provinces.provinces
      // getCityListTree().then(res => {
      //   this.cityList = res.data
      // })
    },
  },
  mounted() {
    this.getCityListTree()
    this.getLiaisonRecruitment()
  },
};
</script>

<style lang="less" scoped>
.qualityControl-box {
  padding-bottom: 20px;
}

.recruitment-box {
  background: #fff;
  text-align: left;
  border-radius: 6px;
  margin-top: 25px;
  padding: 40px 50px 10px 50px;

  /deep/.el-select {
    width: 100%;
  }

  /deep/.el-cascader {
    width: 100%;
  }
}

.recruitment-title {
  color: #A41218;
  font-size: 32px;
  font-weight: bold;
  line-height: 32px;
  margin-bottom: 25px;
  text-align: center;
}

.bt {
  background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
  color: #fff;
  font-size: 16px;
  height: 44px;
  border-radius: 50px;
  width: 255px;
  border: none;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruitment/index.vue